import { ParrentModel } from './parrentModel';

class Payments extends ParrentModel<PaymentsType> {}

export { Payments };
